import React from "react";
import PropTypes from "prop-types";

const SmsNonCompliantText = ({ className }) => <div className={`tw-text-14d tw-text-gray-50 ${className}`}>To avoid having texts sent from your Brivity Number become undeliverable, please ensure your text does not include non-compliant content. <a href="https://www.brivityknowledge.com/docs/sms-compliance-checklist" target='_blank' className="tw-text-theme-text-button-color" rel='noreferrer'>Learn more.</a></div>

export default SmsNonCompliantText;

SmsNonCompliantText.propTypes = {
  className: PropTypes.string,
};

SmsNonCompliantText.defaultProps = {
  className: "",
};